import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Product } from '../product.model';

@Component({
  selector: 'app-product-other-form',
  templateUrl: './product-other-form.component.html',
  styleUrls: ['./product-other-form.component.scss']
})
export class ProductOtherFormComponent {
  @Input() public element: Product = new Product();
  @Output() public elementChange: EventEmitter<Product> = new EventEmitter<Product>();
  
}
